import {
  ATTENTION_STATUS_BITS,
  type TAttentionStatusActionId,
  type TAttentionStatusRole,
} from 'partner360/entities/attentionStatuses'

/** How many open items each side of a plan holds, from the reader's own tab and the others'. */
export interface IAttentionReminderItems {
  pbmItems: number
  managerItems: number
}

/**
 * The reminders a status hides because of whose items are open, as `plans/P360-6305/Attention
 * Statuses.xlsx` rows 15 and 19 say:
 *
 * - H2 review: the PBM reminds the manager only once their own items are done, the manager reminds
 *   the PBM likewise, anyone else reminds each side that has items.
 * - Pending actions: every reader reminds only the side that has items.
 *
 * Other statuses hide nothing.
 */
export const getAttentionRemindersHiddenByItems = (
  bitValue: number,
  role: TAttentionStatusRole,
  { pbmItems, managerItems }: IAttentionReminderItems
): TAttentionStatusActionId[] => {
  const hidden: TAttentionStatusActionId[] = []
  const hide = (actionId: TAttentionStatusActionId, when: boolean) => {
    if (when) hidden.push(actionId)
  }

  if (bitValue === ATTENTION_STATUS_BITS.h2Review && role === 'pbm') {
    hide('remindManager', pbmItems > 0)
  } else if (bitValue === ATTENTION_STATUS_BITS.h2Review && role === 'manager') {
    hide('remindPbm', managerItems > 0)
  } else if (
    bitValue === ATTENTION_STATUS_BITS.h2Review ||
    bitValue === ATTENTION_STATUS_BITS.pendingActions
  ) {
    hide('remindPbm', pbmItems === 0)
    hide('remindManager', managerItems === 0)
  }

  return hidden
}
